import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import moment, { Moment } from "moment";
import "react-day-picker/dist/style.css";
const greenCalendar = require("../../images/green-calendar.svg");
import { MonthDateModal } from "./MonthDateModal";

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

type NullableMoment = Moment | null;

export type DateType = {
  day: number | null;
  month: number;
  year: number;
};

const DateTab = ({
  date,
  updateDate,
  onCancel
}: {
  date: DateType | null;
  updateDate: (date: DateType) => void;
  onCancel: () => void;
}) => {
  const [datePicker, setDatePicker] = useState(!date);
  const initialDate = {
    day: null,
    month: moment().month(),
    year: moment().year()
  };
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (date) updateDate(date);
  }, [date]);

  const dateSearched =
    date &&
    (date.day ? (
      <span>
        Events on{" "}
        <span className="date">
          {MONTHS[date.month]} {date.day}, {date.year}
        </span>
      </span>
    ) : (
      <span>
        Events in{" "}
        <span className="date">
          {MONTHS[date.month]}, {date.year}
        </span>
      </span>
    ));

  return (
    <div className="tab-pane fade active in ds" id="tab-date">
      <div className="search-bar flex-row date-search">
        <a href="#" className="date-icon-link">
          <img src={greenCalendar} alt="" />
        </a>
        <strong className="date-searched">{dateSearched}</strong>
        <a className="change-link" onClick={() => setDatePicker(true)}>
          Change
        </a>
      </div>
      {datePicker && (
        <MonthDateModal
          date={date || initialDate}
          updateDate={newDate => {
            updateDate(newDate);
          }}
          hideDatePicker={() => {
            setDatePicker(false);
          }}
          onCancel={onCancel}
        />
      )}
    </div>
  );
};

export default DateTab;
